import { Component, h } from 'preact';

class TcrAppBar extends Component
{
    constructor(props)
    {
        super(props);

        this.toggleMenu = this.toggleMenu.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);

        this.state = {
            actions: props.config.actions || []
        }
    }

    componentWillReceiveProps(nextProps)
    {
        this.setState({
            actions: nextProps.config.actions || []
        });
    }

    onLogoClicked(e)
    {
        if (typeof this.props.onLogoClicked === 'function')
        {
            this.props.onLogoClicked(e);
        }
        else if (typeof this.props.config.onLogoClicked === 'function')
        {
            this.props.config.onLogoClicked(e);
        }
    }

    toggleMenu()
    {
        if (typeof this.props.onToggleMenu === 'function')
        {
            this.props.onToggleMenu();
        }
    }

	render()
	{
        if (!this.props.config || !this.props.config.visible) return;
        
        var i = 0;
        let actions = (this.state.actions).map(a => 
        {
            if (a.type =='button')
            {
                return (
                    <div class="button" onClick={a.run}>
                        <div class="label">{a.label}</div>
                    </div>
                );
            }
            else if (a.type =='custom')
            {
                let classes = ['action', ...a.classes].join(' ');
                return (
                    <div class={classes} data-type="custom">
                        {a.content}
                    </div>
                );
            }
            else if (a.type == 'menu')
            {
                i++;
                let style = {
                    WebkitMaskImage: 'url(' + a.image + ')',
                    maskImage: 'url(' + a.image + ')',
                    backgroundColor: a.color
                };
                var open = 'open-menu-' + i;
                var toggle = {};
                toggle[open] = !this.state[open];
                var close = {};
                close[open] = false;
                let menuItems = a.items.map(m => 
                {
                    if (m.sep) return <div class="menu-sep"></div>;
                    return (
                        <div class="menu-item" onClick={m.run}>{m.label}</div>
                    );
                });
                return (
                    <div class="action" tabindex="0" data-type="menu" data-open={this.state[open]} onClick={() => { this.setState(toggle); }} onBlur={() => { this.setState(close); }}>
                        <div class="tcr-icon" data-icon={a.icon}></div>
                        <div class="img" data-image={!!a.image} style={style}></div>
                        <div class="menu">
                            {menuItems}
                        </div>
                    </div>
                );
            }
            else
            {
                let style = {
                    WebkitMaskImage: 'url(' + a.image + ')',
                    maskImage: 'url(' + a.image + ')',
                    backgroundColor: a.color
                };
                return (
                    <div class="action" onClick={a.run}>
                        <div class="tcr-icon" data-icon={a.icon}></div>
                        <div class="img" data-image={!!a.image} style={style}></div>
                    </div>
                );
            }
        });

        let barStyle = {};
        if (this.props.config.backgroundColor)
        {
            barStyle.backgroundColor = this.props.config.backgroundColor;
        }
        if (this.props.config.color)
        {
            barStyle.color = this.props.config.color;
        }
        if (this.props.config.borderColor)
        {
            barStyle.borderBottomColor = this.props.config.borderColor;
        }
        let logoStyle = {};
        if (this.props.config.logo)
        {
            logoStyle.backgroundImage = `url(${this.props.config.logo})`;
        }
        else if (this.props.config.maskedLogo)
        {
            logoStyle.maskImage = `url(${this.props.config.maskedLogo})`;
            logoStyle.backgroundColor = this.props.config.color;
        }
        let barDesign = '';
        if (this.props.config.design)
        {
            barDesign = this.props.config.design;
        }
        let logo;
        if (this.props.config.logo)
        {
            logo = <div class="logo" style={logoStyle} onClick={this.onLogoClicked}></div>;
        }
        else if (this.props.config.maskedLogo)
        {
            logo = <div class="masked_logo" style={logoStyle} onClick={this.onLogoClicked}></div>;
        }

		return (
			<div class="app-bar" data-menu={this.props.showMenu} data-design={barDesign} style={barStyle} >
                <div class="menu-icon" data-has-menu={this.props.hasMenu} onClick={this.toggleMenu}><div></div></div>
                {logo}
                <div class="actions">
                    {actions}
                </div>
            </div>
		);
	}
}

export { TcrAppBar };
